export const GET_PRODUCTS = 'GET_PRODUCTS';
export const SET_PRODUCT = 'SET_PRODUCT';


